export type SentInfo =
  | { mode: 'email'; email: string; invoiceCount: number }
  | { mode: 'download'; invoiceCount: number }

type Props = {
  info: SentInfo
  onReset: () => void
}

export default function SuccessView({ info, onReset }: Props) {
  if (info.mode === 'email') {
    return (
      <div class="sis-success">
        <div class="sis-success-icon" aria-hidden="true">✓</div>
        <h2 class="sis-success-title">Check your inbox</h2>
        <p class="sis-success-body">
          We've sent a download link for <strong>{info.invoiceCount}</strong>{' '}
          {info.invoiceCount === 1 ? 'invoice' : 'invoices'} to{' '}
          <strong class="sis-mono">{info.email}</strong>. The link is good for
          7 days.
        </p>
        <p class="sis-success-spam">
          Don't see it? Check your <strong>spam</strong> or{' '}
          <strong>promotions</strong> folder — automated emails sometimes get
          filtered.
        </p>
        <button type="button" class="sis-button" onClick={onReset}>
          Try another PDF
        </button>
      </div>
    )
  }

  return (
    <div class="sis-success">
      <div class="sis-success-icon" aria-hidden="true">✓</div>
      <h2 class="sis-success-title">Downloads started</h2>
      <p class="sis-success-body">
        Your browser is downloading <strong>{info.invoiceCount}</strong>{' '}
        {info.invoiceCount === 1 ? 'file' : 'files'}. Check your downloads
        folder.
      </p>
      <button type="button" class="sis-button" onClick={onReset}>
        Try another PDF
      </button>
    </div>
  )
}
